// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__ZCS0K","name":"ConsentHeader_name__1aDDm","birthday":"ConsentHeader_birthday__3ttVG","skeleton":"ConsentHeader_skeleton__DUn2k"};